module.exports = __webpack_public_path__ + "../resources/img/ic_re_thumbsup_shine.7f4cc3da.svg";